import { FC } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 4
  },
  clickable: {
    cursor: 'pointer'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    borderRadius: 16,
    padding: '4px 8px',
    backgroundColor: '#FA2020',
    width: 'fit-content'
  },
  icon: {
    width: 14,
    height: 14,
    color: '#ffffff'
  },
  expiredText: {
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '16px',
    color: '#ffffff'
  },
  updateNeededText: {
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '16px',
    color: '#FA2020',
    textDecoration: 'underline'
  }
}));

interface ExpiredBadgeProps {
  onClick?: () => void;
}

export const ExpiredBadge: FC<ExpiredBadgeProps> = ({ onClick }) => {
  const classes = useStyles();

  const handleClick = (e: React.MouseEvent) => {
    if (!onClick) return;
    e.stopPropagation();
    onClick();
  };

  return (
    <Box
      className={`${classes.container} ${onClick ? classes.clickable : ''}`}
      onClick={handleClick}>
      <Box className={classes.badge}>
        <ErrorOutlineIcon className={classes.icon} />
        <span className={classes.expiredText}>Expired</span>
      </Box>
      {onClick && (
        <span className={classes.updateNeededText}>Update Needed</span>
      )}
    </Box>
  );
};
